module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_myreal_m.28e09932db6bd7f1229e729ca6876091.png";